import React from 'react';
import navigationData from '../data/navigation.json';
import ThemeToggle from './ThemeToggle'; // Import the ThemeToggle component

interface HeaderProps {
  activeTab: string;
  setActiveTab: (tab: string) => void;
}

const Header: React.FC<HeaderProps> = ({ activeTab, setActiveTab }) => {
  return (
    <header>
      <div className="header-content">
        <div className="logo-and-title-container">
          <img src="/challodelhi_logo.jpg" className="cafe-logo" alt="Chalo dilli Paratha Cafe Logo" />
          <h1>Chalo dilli Paratha Cafe</h1>
        </div>
        <ThemeToggle /> {/* Place the ThemeToggle component here */}
      </div>
      <nav>
        <ul>
          {navigationData.map((item) => (
            <li key={item.id}>
              <button
                type="button"
                className={`nav-link ${activeTab === item.id ? 'active' : ''}`}
                onClick={() => setActiveTab(item.id)}
              >
                {item.name}
              </button>
            </li>
          ))}
        </ul>
      </nav>
    </header>
  );
};

export default Header;
